import { getState, switchTab, subscribe, type TabId } from '../views.js';

const TABS: { id: TabId; label: string; icon: string }[] = [
  { id: 'today', label: '今日', icon: '📝' },
  { id: 'forest', label: '森', icon: '🌳' },
  { id: 'settings', label: '設定', icon: '⚙️' },
];

export function renderTabBar(root: HTMLElement): () => void {
  const update = () => {
    const { activeTab } = getState();
    root.innerHTML = `
      <nav class="tab-bar" role="navigation" aria-label="主要ナビゲーション">
        ${TABS.map(t => `
          <button
            class="tab-bar__item ${t.id === activeTab ? 'is-active' : ''}"
            data-tab="${t.id}"
            aria-current="${t.id === activeTab ? 'page' : 'false'}"
          >
            <span class="tab-bar__icon" aria-hidden="true">${t.icon}</span>
            <span class="tab-bar__label">${t.label}</span>
          </button>
        `).join('')}
      </nav>
    `;
    root.querySelectorAll<HTMLButtonElement>('button[data-tab]').forEach(btn => {
      btn.addEventListener('click', () => switchTab(btn.dataset.tab as TabId));
    });
  };
  update();
  const unsubscribe = subscribe(update);
  return unsubscribe;
}
